import { useEffect, useRef, useState } from 'react';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link,
    useNavigate
} from "react-router-dom";
import MTable from '../../Components/MTable/MTable';
import { InputSwitch } from 'primereact/inputswitch';
import { createUserV2, getRoles, getUserBranch, getMHCDealers, getUserByUserIdV2, getUsersMI, getUsersSAP, getUserV2, resetPassword, updateUserV2 } from '../../Service/UserService';
import { useForm, Controller } from 'react-hook-form';
import Overlay from '../../Components/Overlay';
import Swal from 'sweetalert2';
import Select from "react-select";
import { isObjectEmpty } from '../../Utils/Utils';
import { includes, set } from 'lodash';
import { getAllInsertedDealers, getDealerOrderTypes } from '../../Service/DealerService';

const date = new Date();
const { $, setupDigitInput } = window;
const User = () => {
    const navigate = useNavigate();
    const { register, getValues, handleSubmit, reset, setValue, watch, control, formState: { errors }, clearErrors } = useForm({
        values: {
            user_id: (date.getYear() - 100) + ('' + (date.getMonth() + 1)).padStart(2, '0') + '.E_ _ _ _',
            user_sap_code: 2,
            user_name: '',
            user_password: '',
            user_branch: '',
            user_branch_name: '',
            user_role: '',
            user_role_name: '',
            user_email: '',
            user_email_additional: '',
            user_enabled: true,
            job_title: '',
            work_location: '',
            supervisorid: '',
            organization_unit: '',
            job_status: '',
            cost_center: '',
            gender: '',
            phone: ''
        }
    });
    const tableUsers = useRef();
    const tableUser = useRef();
    const tableMHC = useRef();
    const tableDealer = useRef();
    const user_password = useRef({});
    user_password.current = watch("user_password", "");
    const [reset_password_data, setResetPasswordData] = useState({
        user_id: "",
        new_password: ""
    })
    const [role_value, setRoleValue] = useState("");
    const [order_types, setOrderTypes] = useState({
        FGS: "",
        TRD: "",
        PMR: "",
        SPL: "",
        PMT: "",
        DSL: ""
    });


    const setCardCodeOrderType = (order_type, val) => {
        let types = Object.assign({}, order_types);
        types[order_type] = val;
        setOrderTypes(types);
    }
    const [selected_dealer, setSelectedDealer] = useState({});//[
    const [state, setStates] = useState({
        id: 0,
        processing: false,
        isSelected: true,
        roles: [],
        supervisors: [],
        user_sap_code: '',
        user_sap_code_mhc: '',
        usersSAP: [],
        usersMI: [],
        user_id: (date.getYear() - 100) + ('' + (date.getMonth() + 1)).padStart(2, '0') + '.E_ _ _ _',
        isNew: false,
    })

    useEffect(() => {
        const requests = [
            getRoles({ perpage: 100, select: '_id,name', filter: 'is_active:true' }),
            getUsersMI({ perpage: 200 }).then(res => res.data),
            getUsersSAP({ perpage: 500 }).then(res => res.data)
        ];

        Promise.all(requests).then(response => {
            const [roleResponse, _usrMI, _usrSAP] = response;
            //const [roleResponse ] = response;
            const { data: { data } } = roleResponse;

            let _newUsrSAP = [];
            if (_usrSAP && _usrSAP.length)
                _newUsrSAP = _usrSAP.map(item => {
                    return {
                        label: item.SlpName,
                        value: item.SlpCode
                    }
                })

            let _newUsrMI = _usrMI.map(item => {
                return {
                    label: item.SlpName,
                    value: item.SlpCode
                }
            })

            setState({ roles: data, usersMI: _newUsrMI, usersSAP: _newUsrSAP })
            //setState({ roles: data });
        });
        setupDigitInput();
    }, [])

    const setState = value => {
        setStates({ ...state, ...value });
    }

    const onAddData = () => {
        reset({
            user_id: (date.getYear() - 100) + ('' + (date.getMonth() + 1)).padStart(2, '0') + '.E_ _ _ _',
            // user_sap_code: '',
            // user_sap_code_mhc: '',
            user_name: '',
            user_password: '',
            user_branch: '',
            user_branch_name: '',
            user_role: '',
            user_role_name: '',
            user_email: '',
            user_email_additional: '',
            user_enabled: true,
            job_title: '',
            work_location: '',
            supervisorid: '',
            organization_unit: '',
            job_status: '',
            cost_center: '',
            gender: '',
            phone: ''
        });
        setState({ isNew: true });
        $("#modal-form").modal();
    }


    const onEdit = item => () => {
        getUserByUserIdV2(item.user_id).then(response => {
            setState({
                id: item._id, isNew: false,
                user_sap_code: response.data.user_sap_code,
                user_sap_code_mhc: response.data.user_sap_code_mhc
            });

            if (response?.data?.order_types) {
                let types = [];
                response.data.order_types.forEach((item) => {
                    types[item.order_type] = item.card_code;
                });

                setOrderTypes(types);
            }

            if (response?.data?.data_dealer) {
                setSelectedDealer(response.data.data_dealer[0]);
            }

            setRoleValue(response.data.user_role_name);
            reset(response.data);
            $("#modal-form").modal();
        });
    };

    const onResetPassword = (item) => {
        setResetPasswordData({
            ...reset_password_data,
            user_id: item.user_id
        });
        $("#modal-reset").modal();
    }

    //useEffect(() => console.log(reset_password_data), [reset_password_data])

    const resetUserPassword = (e) => {
        e.preventDefault();
        resetPassword(reset_password_data).then(res => {
            if (res.data.status == 200) {
                Swal.fire({
                    icon: 'success',
                    title: 'Success',
                    text: res.data.message
                }).then(r => $("#modal-reset").modal('hide'));
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Unexpected Error Occured',
                })
            }
        }).catch(err => {
            Swal.fire({
                icon: 'error',
                title: 'Unexpected Error Occured',
            })
        });
    }

    const isRequiredForFranchise = (role) => {
        const roles = ['Sales Consultant - MHC Dealer', 'MHC Owner - MHC Dealer', 'SO Payment Verificator - MHC Dealer', 'Accounting Staff'];

        if (roles.includes(role)) return false;
        else return true;
    }

    const isSupportingUserRole = (role) => {
        const roles = ['Accounting Staff'];

        if (roles.includes(role)) return false;
        else return true;
    }

    const onRoleChange = e => {
        const selectedRole = roles.find(x => x._id == e.target.value);
        setValue('user_role_name', selectedRole.name);
        setRoleValue(selectedRole.name);
    };

    const onSelectSupervisor = item => () => {
        setValue('supervisorid', item.user_id);
        clearErrors('supervisorid');
        $('#modal-spv').modal('hide');
    }

    const onSelectDealer = item => () => {
        let default_cardcode = item.cardcode
        getAllInsertedDealers({ filter: "cardcode:" + item.cardcode }).then(res => {
            if (res.data.status == 200 || res.status == 200) {
                if (res.data?.data?.length && res.data.data[0].cardcode == item.cardcode) {
                    let dealer_result = { ...res.data.data[0] };
                    getDealerOrderTypes({ bplid: res.data.data[0].bplid }).then(res => {
                        setValue('user_branch', dealer_result.bplid);
                        setValue('user_branch_name', dealer_result.bplname);
                        setValue('user_dealer_code', dealer_result.cardcode);
                        setSelectedDealer(item);
                        let types = [];
                        res.data.forEach((item) => {
                            if (item.order_type == "FGS") types[item.order_type] = default_cardcode;
                            else types[item.order_type] = item.card_code;
                        });
                        setOrderTypes(types);
                        $('#modal-mhc').modal('hide');
                    });
                } else {
                    setValue('user_branch', (Date.now() % 10000) * -1);
                    setValue('user_branch_name', item.cardname);
                    setValue('user_dealer_code', item.cardcode);
                    setSelectedDealer(item);
                    let types = [];
                    console.log(default_cardcode);
                    types["FGS"] = item.cardcode;
                    setOrderTypes(types);
                    $('#modal-mhc').modal('hide');
                }
            }
        }).catch(err => {
            console.log(err);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: "An unexpected error occurred while fetching dealer data. Please try again later."
            })
        })
        /*setValue('user_dealer_code', item.cardcode);
        setSelectedDealer(item);
        $('#modal-mhc').modal('hide');*/
    }

    const onSelectMHC = item => () => {
        setValue('user_branch', item.BPLId);
        setValue('user_branch_name', item.BPLFrName);
        clearErrors('user_branch_name');
        $('#modal-mhc').modal('hide');
    }

    const onShowUsersModal = () => {
        $('#modal-spv').modal();
        tableUser.current.reset();
    }

    const onShowNHCModal = () => {
        if (role_value) {
            $('#modal-mhc').modal();
            if (isRequiredForFranchise(role_value)) tableMHC.current.reset();
            else tableDealer.current.reset();
        }

    }

    const onSubmit = (data) => {
        let {
            user_id, user_name, user_password, user_branch, user_branch_name,
            user_role, user_role_name, user_email, user_enabled, job_title,
            work_location, supervisorid, job_status, cost_center, gender, phone, user_email_additional
        } = data;

        if (user_role_name == "Sales Consultant") {
            if (!user_email_additional) {
                Swal.fire({
                    icon: 'error',
                    title: 'Additional email required for sales consultants',
                    showConfirmButton: false,
                    timer: 2000,
                    timerProgressBar: true,
                });
                return;
            }
        }
        if (user_sap_code == "" && isSupportingUserRole(role_value)) {
            Swal.fire({
                icon: 'error',
                title: 'User SAP Required',
                showConfirmButton: false,
                timer: 2000,
                timerProgressBar: true,
            });
            return;
        }


        const payload = {
            user_id, user_sap_code, user_sap_code_mhc, user_name, user_password, user_branch, user_branch_name,
            user_role, user_role_name, user_email, user_enabled, job_title,
            work_location, supervisorid, job_status, cost_center, gender, phone, user_email_additional
        };
        if (!isRequiredForFranchise(role_value)) {
            payload.user_sap_code_mhc = "-1";
            payload.supervisorid = "-";
            payload.data_dealer = { ...selected_dealer };
            payload.data_dealer.order_types = { ...order_types };
        }
        if (!isSupportingUserRole(role_value)) {
            payload.user_branch = "-";
            payload.user_branch_name = "";
            payload.user_sap_code = "-1";
        }

        const request = isNew ? createUserV2(payload) : updateUserV2(id, payload);
        request.then(res => {
            Swal.fire({
                icon: 'success',
                title: 'Success',
                text: `${(isNew ? 'Create' : 'Update')} user success!`
            }).then(res => {
                $('#modal-form').modal('hide');
                tableUsers.current.refresh();
                setOrderTypes({
                    FGS: "",
                    TRD: "",
                    PMR: "",
                    SPL: "",
                    PMT: "",
                    DSL: ""
                });
            });
        }).catch(({ response }) => {
            const { errors } = response?.data;
            const { message } = response?.data;
            let error_msg = message;
            if (!isObjectEmpty(errors)) {
                let key = Object.keys(errors)[0];
                if (Array.isArray(errors[key]) && errors[key].length > 0) error_msg = errors[key][0]// check if the error is in array form. If it is, return the first element of it.
                else {
                    error_msg = errors[key];
                }
            }
            Swal.fire({
                icon: 'error',
                title: `${(isNew ? 'Create' : 'Update')} user error!`,
                text: error_msg
            });
        }).finally(() => {
            setState({ processing: false })
        })
    }


    const columns = [
        { id: 1, title: 'User ID', field: 'user_id', sortable: true },
        { id: 2, title: 'Username', field: 'user_name', sortable: true },
        { id: 3, title: 'Email', field: 'user_email', sortable: true },
        { id: 4, title: 'Role', field: 'user_role_name', sortable: true },
        /*{
            id: 5,
            title: 'Active',
            field: 'user_enabled',
            sortable: true,
            options: [
                {
                    label: 'Active',
                    value: true
                },
                {
                    label: 'Inactive',
                    value: false
                }
            ],
            render: data => {
                return <InputSwitch checked={data.user_enabled} />;
            },
        }*/,
        {
            id: 6,
            title: 'Action',
            render: item => {
                return (
                    <div style={{ width: 100 }}>
                        <a
                            onClick={onEdit(item)}
                            style={{
                                cursor: 'pointer',
                                color: 'green',
                                display: 'inline-block',
                                marginRight: 20
                            }}
                        >
                            <i className="fas fa-edit" />
                            <span style={{ marginLeft: 10 }}>View</span>
                        </a>
                        <a
                            onClick={() => onResetPassword(item)}
                            style={{
                                cursor: 'pointer',
                                color: '#77C3EC',
                                display: 'inline-block',
                                marginRight: 20
                            }}
                        >
                            <i className="fas fa-undo" />
                            <span style={{ marginLeft: 10 }}>Reset Password</span>
                        </a>
                    </div>
                );
            },
        },
    ];

    const onCloseUserModal = (e) => {
        e.preventDefault();
        setOrderTypes({
            FGS: "",
            TRD: "",
            PMR: "",
            SPL: "",
            PMT: "",
            DSL: ""
        });
        $('modal-user').hide();
    }

    const columnsUser = [
        { id: 1, title: 'User ID', field: 'user_id', sortable: true },
        { id: 2, title: 'Username', field: 'user_name', sortable: true },
        { id: 3, title: 'Email', field: 'user_email', sortable: true },
        { id: 4, title: 'Branch', field: 'user_branch_name', sortable: true },
        {
            id: 5,
            title: 'Action',
            render: item => {
                return (
                    <div>
                        <a
                            onClick={onSelectSupervisor(item)}
                            style={{
                                cursor: 'pointer',
                                color: 'green',
                                display: 'inline-block',
                                marginRight: 20
                            }}
                        >
                            <i className="fas fa-check" />
                            <span style={{ marginLeft: 10 }}>Select</span>
                        </a>
                    </div>
                );
            },
        },
    ];

    const columnsDealer = [
        { id: 1, title: 'Card Code', field: 'cardcode', sortable: true },
        { id: 2, title: 'Card Name', field: 'cardname', sortable: true },
        {
            id: 5,
            title: 'Action',
            render: item => {
                return (
                    <div>
                        <a
                            onClick={onSelectDealer(item)}
                            style={{
                                cursor: 'pointer',
                                color: 'green',
                                display: 'inline-block',
                                marginRight: 20
                            }}
                        >
                            <i className="fas fa-check" />
                            <span style={{ marginLeft: 10 }}>Select</span>
                        </a>
                    </div>
                );
            },
        },
    ];

    const columnsMHC = [
        { id: 2, title: 'MHC Name', field: 'BPLName', sortable: true },
        { id: 3, title: 'MHC Full Name', field: 'BPLFrName', sortable: true },
        { id: 4, title: 'City', field: 'City', sortable: true },
        {
            id: 5,
            title: 'Action',
            render: item => {
                return (
                    <div>
                        <a
                            onClick={onSelectMHC(item)}
                            style={{
                                cursor: 'pointer',
                                color: 'green',
                                display: 'inline-block',
                                marginRight: 20
                            }}
                        >
                            <i className="fas fa-check" />
                            <span style={{ marginLeft: 10 }}>Select</span>
                        </a>
                    </div>
                );
            },
        },
    ];

    const onChangeSAPCode = (e) => {
        setState({ ...state, user_sap_code_mhc: e.value })
    }

    const propsTable = { columns, getData: getUserV2, showIndex: true, showAddButton: true, onAddData };
    const propsTableUser = { columns: columnsUser, getData: getUserV2, showIndex: true };
    const propsTableDealer = { columns: columnsDealer, getData: getMHCDealers, showIndex: true, enablePerPage: false };
    const propsTableMHC = { columns: columnsMHC, getData: getUserBranch, showIndex: true };
    const { roles, user_id, processing, id, isNew, usersMI, usersSAP, user_sap_code, user_sap_code_mhc } = state;

    return (
        <div className="content-wrapper">
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h2 className="title-breadcrum"> List User</h2>
                        </div>
                    </div>
                </div>
            </div>
            <section className="content">
                <div className="container-fluid">
                    <div className="card shadow mb-4">
                        <div className="card-body">
                            <div className='table-responsive'>
                                <MTable ref={tableUsers} {...propsTable} />
                            </div>
                        </div>
                    </div>

                    <div id="modal-form" className='modal fade'>
                        <Overlay display={state.processing} />
                        <form name="form-customer" onSubmit={handleSubmit(onSubmit)}>
                            <div className='modal-dialog modal-dialog-centered modal-lg' id="modal-user" style={{ maxWidth: 1200 }}>
                                <div className='modal-content'>
                                    <div className='modal-header'>
                                        <h5 className="modal-title"> New User</h5>
                                        <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={(e) => onCloseUserModal(e)}>
                                            <span aria-hidden="true">×</span>
                                        </button>
                                    </div>
                                    <div className='modal-body' style={{ paddingLeft: 40 }}>
                                        <div style={{ marginBottom: "12px", fontWeight: 700 }}>* Please select role first</div>
                                        <div className="row">
                                            <div className="col-md-5" >
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <div className="form-group" >
                                                            <label htmlFor="">User ID</label>
                                                            <div className="form-control">{getValues('user_id')}</div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                            <div className="col-md-1"></div>
                                            <div className="col-md-5" >
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <label htmlFor="">Role</label>
                                                            <select className="form-control" {...register('user_role', { required: 'User role is required', onChange: onRoleChange })}>
                                                                <option value=''>--Select Role--</option>
                                                                {
                                                                    roles.map((item, i) => (<option key={`role-#${i}`} value={item._id} >{item.name}</option>))
                                                                }
                                                            </select>
                                                            {errors.user_role && <span className='text-danger' style={{ fontSize: 12 }}>{errors.user_role.message}</span>}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-5" >
                                                <div className="form-group">
                                                    <label htmlFor="">Modena Home Center {isSupportingUserRole(role_value) && <span style={{ color: "red", fontSize: "14px" }}>**</span>}</label>
                                                    <div className="input-group mb-3">
                                                        <input type="text" className="form-control" readOnly={true} {...register('user_branch_name', { required: (isSupportingUserRole(role_value) ? 'Branch is required' : "") })}
                                                            disabled={!role_value} />
                                                        <div className="input-group-append">
                                                            <button className="btn btn-outline-secondary" type="button" onClick={onShowNHCModal}
                                                                disabled={!isSupportingUserRole(role_value)}
                                                            ><i className="fa fa-search"></i></button>
                                                        </div>
                                                    </div>
                                                    {errors.user_branch_name && <span className='text-danger' style={{ fontSize: 12 }}>{errors.user_branch_name.message}</span>}
                                                </div>
                                            </div>
                                            <div className="col-md-1"></div>
                                            <div className="col-md-5">
                                                <div className="form-group">
                                                    <label htmlFor="">Default Warehouse</label>
                                                    <div className="form-control">Warehouse Stock</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-5" >
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <div className="form-group" >
                                                            <label htmlFor="">SAP Code (MHC) {isRequiredForFranchise(role_value) && <span style={{ color: "red", fontSize: "14px" }}>**</span>}</label>
                                                            <Select
                                                                options={usersSAP}
                                                                onChange={onChangeSAPCode}
                                                                value={usersSAP.filter(function (option) {
                                                                    return option.value === user_sap_code_mhc;
                                                                })}
                                                                isDisabled={!isRequiredForFranchise(role_value)} />

                                                            {errors.user_sap_code_mhc && <span className='text-danger' style={{ fontSize: 12 }}>{errors.user_sap_code_mhc.message}</span>}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-1"></div>
                                            <div className="col-md-5" >
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <div className="form-group" >
                                                            <label htmlFor="">SAP Code (MODENA) {isSupportingUserRole(role_value) && <span style={{ color: "red", fontSize: "14px" }}>**</span>}</label>
                                                            <Select
                                                                options={usersMI}
                                                                onChange={(e) => setState({ ...state, user_sap_code: e.value })}
                                                                value={usersMI.filter(function (option) {
                                                                    return option.value === user_sap_code;
                                                                })}
                                                                isDisabled={!isSupportingUserRole(role_value)}
                                                            />
                                                            {errors.user_sap_code && <span className='text-danger' style={{ fontSize: 12 }}>{errors.user_sap_code.message}</span>}
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-5">
                                                <div className="form-group">
                                                    <label htmlFor="">User Name <span style={{ color: "red" }}>*</span></label>
                                                    <input {...register('user_name', { required: 'User name is required' })} className="form-control" />
                                                    {errors.user_name && <span className='text-danger' style={{ fontSize: 12 }}>{errors.user_name.message}</span>}
                                                </div>
                                            </div>
                                            <div className="col-md-1"></div>
                                            <div className="col-md-5" >
                                                <div className="form-group">
                                                    <label htmlFor="">Supervisor {isRequiredForFranchise(role_value) && <span style={{ color: "red" }}>*</span>}</label>
                                                    <div className="input-group mb-3">
                                                        <input type="text" className="form-control" readOnly={true} {...register('supervisorid', { required: (isRequiredForFranchise(role_value) ? 'Supervisor is required' : "") })} />
                                                        <div className="input-group-append">
                                                            <button className="btn btn-outline-secondary" type="button" onClick={onShowUsersModal} disabled={!isRequiredForFranchise(role_value)}><i className="fa fa-search"></i></button>
                                                        </div>
                                                    </div>
                                                    {errors.supervisorid && <span className='text-danger' style={{ fontSize: 12 }}>{errors.supervisorid.message}</span>}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-5">
                                                <div className="form-group">
                                                    <label htmlFor="">Email <span style={{ color: "red" }}>*</span></label>
                                                    <input {...register('user_email', {
                                                        required: 'Email is required', pattern: {
                                                            value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                                                            message: "Invalid email format!",
                                                        },
                                                    })} className="form-control" />
                                                    {errors.user_email && <span className='text-danger' style={{ fontSize: 12 }}>{errors.user_email.message}</span>}
                                                </div>
                                            </div>
                                            <div className="col-md-1"></div>
                                            <div className="col-md-5">
                                                <div className="form-group">
                                                    <label htmlFor="">Additional Emails (divide with comma for multiple email) <span style={{ color: "red", fontSize: "14px" }}>**</span></label>
                                                    <input {...register('user_email_additional')} className="form-control" />
                                                    {/*errors.user_email_additional && <span className='text-danger' style={{ fontSize: 12 }}>{errors.user_email_additional.message}</span>*/}
                                                </div>
                                            </div>
                                        </div>
                                        {
                                            isNew && (
                                                <div className="row">
                                                    <div className="col-md-5">
                                                        <div className="form-group">
                                                            <label htmlFor="">Password <span style={{ color: "red" }}>*</span></label>
                                                            <input type="password" {...register('user_password', { required: 'Password is required' })} className="form-control" />
                                                            {errors.user_password && <span className='text-danger' style={{ fontSize: 12 }}>{errors.user_password.message}</span>}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-1"></div>
                                                    <div className="col-md-5">
                                                        <div className="form-group">
                                                            <label htmlFor="">Confirm Password <span style={{ color: "red" }}>*</span></label>
                                                            <input type="password" {...register('confirm_password', { required: 'Confirm Passowrd is required', validate: val => val == user_password.current || 'Password is not match' })} className="form-control" />
                                                            {errors.confirm_password && <span className='text-danger' style={{ fontSize: 12 }}>{errors.confirm_password.message}</span>}
                                                        </div>
                                                    </div>

                                                </div>
                                            )
                                        }
                                        <div className="row">
                                            <div className="col-md-5">
                                                <div className="form-group">
                                                    <label htmlFor="">Gender</label>
                                                    <select name="gender" {...register('gender')} className="form-control">
                                                        <option>--Select MHC--</option>
                                                        <option value="MALE">MALE</option>
                                                        <option value="FEMALE">FEMALE</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-1"></div>
                                            <div className="col-md-5">
                                                <div className="form-group">
                                                    <label htmlFor="">Work Location <span style={{ color: "red" }}>*</span></label>
                                                    <div>
                                                        <input name="work_location" {...register('work_location', { required: 'Work location is required' })} className="form-control" />
                                                        {errors.work_location && <span className='text-danger' style={{ fontSize: 12 }}>{errors.work_location.message}</span>}
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                        <div className="row">
                                            <div className="col-md-5">
                                                <div className="form-group">
                                                    <label htmlFor="">Job Status</label>
                                                    <input name="job_status" {...register('job_status')} className="form-control" />
                                                </div>
                                            </div>
                                            <div className="col-md-1"></div>
                                            <div className="col-md-5">
                                                <div className="form-group">
                                                    <label htmlFor="">Job Title <span style={{ color: "red" }}>*</span></label>
                                                    <input {...register('job_title', { required: 'Job title is required' })} name="job_title" className="form-control" />
                                                    {errors.job_title && <span className='text-danger' style={{ fontSize: 12 }}>{errors.job_title.message}</span>}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">

                                            <div className="col-md-5">
                                                <div className="form-group">
                                                    <label htmlFor="">Phone</label>
                                                    <div>
                                                        <input name="phone" {...register('phone')} className="form-control" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-1"></div>
                                            <div className="col-md-5">
                                                <div className="form-group">
                                                    <label htmlFor="">Cost Center</label>
                                                    <div>
                                                        <input name="cost_center" {...register('cost_center')} className="form-control" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {role_value == "Sales Consultant - MHC Dealer" &&
                                            <div className='row' style={{ marginTop: "0.5rem", marginBottom: "0.5rem" }}>
                                                <div className="col-md-5">
                                                    <label style={{ fontWeight: "700" }}>Order Types</label>
                                                    <div className="d-flex" style={{ flexDirection: "column" }}>
                                                        <div className='d-flex align-items-center' style={{ columnGap: "20px", justifyContent: "space-between", marginBottom: "20px" }}>
                                                            <div style={{ paddingLeft: "0.5rem" }}>
                                                                Finish Goods <span style={{ color: "red" }}>*</span>
                                                            </div>
                                                            <div>
                                                                <input required type="text" className="form-control" id="fgs_cardcode" style={{ width: "100%" }} value={order_types["FGS"]} onChange={(e) => setCardCodeOrderType("FGS", e.target.value)} readOnly={true} />
                                                            </div>
                                                        </div>
                                                        <div className='d-flex align-items-center' style={{ columnGap: "20px", justifyContent: "space-between", marginBottom: "20px" }}>
                                                            <div style={{ paddingLeft: "0.5rem" }}>
                                                                Trade In
                                                            </div>
                                                            <div>
                                                                <input type="text" className="form-control" style={{ width: "100%" }} value={order_types["TRD"]} onChange={(e) => setCardCodeOrderType("TRD", e.target.value)} />
                                                            </div>
                                                        </div>
                                                        <div className='d-flex align-items-center' style={{ columnGap: "20px", justifyContent: "space-between", marginBottom: "20px" }}>
                                                            <div style={{ paddingLeft: "0.5rem" }}>
                                                                Pameran
                                                            </div>
                                                            <div>
                                                                <input type="text" className="form-control" style={{ width: "100%" }} value={order_types["PMR"]} onChange={(e) => setCardCodeOrderType("PMR", e.target.value)} />
                                                            </div>
                                                        </div>
                                                        <div className='d-flex align-items-center' style={{ columnGap: "20px", justifyContent: "space-between", marginBottom: "20px" }}>
                                                            <div style={{ paddingLeft: "0.5rem" }}>
                                                                Pameran - Trade In
                                                            </div>
                                                            <div>
                                                                <input type="text" className="form-control" style={{ width: "100%" }} value={order_types["PMT"]} onChange={(e) => setCardCodeOrderType("PMT", e.target.value)} />
                                                            </div>
                                                        </div>
                                                        <div className='d-flex align-items-center' style={{ columnGap: "20px", justifyContent: "space-between", marginBottom: "20px" }}>
                                                            <div style={{ paddingLeft: "0.5rem" }}>
                                                                Display
                                                            </div>
                                                            <div>
                                                                <input type="text" className="form-control" style={{ width: "100%" }} value={order_types["DSL"]} onChange={(e) => setCardCodeOrderType("DSL", e.target.value)} />
                                                            </div>
                                                        </div>
                                                        <div className='d-flex align-items-center' style={{ columnGap: "20px", justifyContent: "space-between", marginBottom: "20px" }}>
                                                            <div style={{ paddingLeft: "0.5rem" }}>
                                                                Solar Panel
                                                            </div>
                                                            <div>
                                                                <input type="text" className="form-control" style={{ width: "100%" }} value={order_types["SPL"]} onChange={(e) => setCardCodeOrderType("SPL", e.target.value)} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>}
                                        <div className='row'>
                                            <div className="col-md-5">
                                                <div className="form-group">
                                                    <label htmlFor="">Active</label>
                                                    <div>
                                                        <Controller name="user_enabled" control={control} render={({ field }) => { return (<InputSwitch {...field} checked={field.value} />) }} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                    <div style={{ paddingLeft: "40px", marginBottom: "10px" }}>
                                        <span style={{ color: "red" }}>*</span> = Mandatory.
                                    </div>
                                    <div style={{ paddingLeft: "40px", marginBottom: "10px" }}>
                                        <span style={{ color: "red" }}>**</span> = Mandatory for Sales Consultants Only.
                                    </div>
                                    <div className="modal-footer">
                                        <button type='button' className='btn btn-outline-secondary' style={{ width: 150 }} data-dismiss="modal" onClick={onCloseUserModal}><i className="fa fa-times"></i> Cancel</button>
                                        {
                                            (!false) && <button className='btn btn-dark' style={{ width: 150 }}><i className="fa fa-save"></i> Save</button>
                                        }
                                    </div>

                                </div>
                            </div>
                        </form>
                    </div>

                    <div id="modal-reset" className='modal fade'>
                        <Overlay display={state.processing} />
                        <form name="form-customer" onSubmit={resetUserPassword}>
                            <div className='modal-dialog modal-dialog-centered modal-lg' style={{ maxWidth: 1200 }}>
                                <div className='modal-content'>
                                    <div className='modal-header'>
                                        <h5 className="modal-title"> Reset Password</h5>
                                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true">×</span>
                                        </button>
                                    </div>
                                    <div className='modal-body' style={{ paddingLeft: 40 }}>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label htmlFor="">User ID</label>
                                                    <input type="email" className="form-control" value={reset_password_data.user_id} onChange={(e) => setResetPasswordData({ ...reset_password_data, user_id: e.target.value })} placeholder="Enter user ID" disabled />
                                                </div>
                                                <div className="form-group" >
                                                    <label htmlFor="">New Password</label>
                                                    <input type="password" className="form-control" value={reset_password_data.new_password} onChange={(e) => setResetPasswordData({ ...reset_password_data, new_password: e.target.value })} placeholder="Enter password" required />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="modal-footer">
                                        <button type='button' className='btn btn-outline-secondary' style={{ width: 150 }} data-dismiss="modal"><i className="fa fa-times"></i> Cancel</button>
                                        {
                                            (!false) && <button className='btn btn-dark' style={{ width: 150 }}><i className="fa fa-save"></i> Save</button>
                                        }
                                    </div>

                                </div>
                            </div>
                        </form>
                    </div>

                    {/***Modal Select User */}
                    <div id="modal-spv" className='modal fade'>
                        <div className="modal-dialog modal-lg" style={{ maxWidth: 1000 }}>
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title"> Select Supervisor</h5>
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">×</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <MTable ref={tableUser} {...propsTableUser} />
                                </div>
                                <div className="modal-footer">
                                    <button type='button' className='btn btn-outline-secondary' style={{ width: 150 }} data-dismiss="modal"><i className="fa fa-times"></i> Close</button>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/***Modal Select MHC */}
                    <div id="modal-mhc" className='modal fade'>
                        <div className="modal-dialog modal-lg" style={{ maxWidth: 1000 }}>
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title"> Select MHC</h5>
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">×</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    {role_value && isRequiredForFranchise(role_value) && <MTable ref={tableMHC} {...propsTableMHC} />}
                                    {role_value && !isRequiredForFranchise(role_value) && <MTable ref={tableDealer} {...propsTableDealer} />}
                                </div>
                                <div className="modal-footer">
                                    <button type='button' className='btn btn-outline-secondary' style={{ width: 150 }} data-dismiss="modal"><i className="fa fa-times"></i> Close</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );

};

export default User;